import store from "../store";

export default async (_to, _from, next) => {
  const { isFirstConfig } = store.getters["app/settings"];
  if (isFirstConfig) return next({ name: "settings.first" });
  next();
};
